// extracted by mini-css-extract-plugin
module.exports = {"serviceItem":"Card_serviceItem__2wHk_","media":"Card_media__2OhgA","iconContainer":"Card_iconContainer__IWA20","icon":"Card_icon__11E4o","mediaBody":"Card_mediaBody__26Jat"};